<div *ngIf="showHelpFloater()">
    <div id="helpFloater" class="help-floater d-none d-md-block">
        <a tabindex="0" data-bs-toggle="modal" data-bs-target="#mdl-need-help"><span translate>FAQ.NEED_HELP</span>&nbsp;<span class="fa fa-caret-right"></span></a>
    </div>
</div>    